import { useMemo } from 'react';
import Reveal from '../components/Reveal';
import { useLanguage } from '../context/LanguageContext';
import { ContentCard, layoutBlocks } from './MediaInitiativePage';

const posterBase = `${process.env.PUBLIC_URL}/sportsclubs`;
const posters = { ar: 'sports-ar.jpeg', en: 'sports-en.jpeg' };
const websiteUrl = 'https://www.hololrealestate.club';

/** Reuses the media initiative page styling (mi-*) and its content-card renderer. */
function SportsClubsPage() {
  const { t, language } = useLanguage();
  const page = t.sportsClubsPage;
  const blocks = useMemo(() => layoutBlocks(page.blocks), [page.blocks]);

  return (
    <main className="inner-page media-initiative-page sports-clubs-page">
      <section className="mi-hero-section">
        <div className="container">
          <Reveal>
            <div className="mi-hero">
              <div className="mi-hero-glow" aria-hidden="true" />
              <h1 className="mi-hero-title">
                <span className="mi-hero-line mi-hero-line-1">{page.hero.title}</span>
                <span className="mi-hero-line mi-hero-line-2">{page.hero.subtitle}</span>
              </h1>
              <p className="mi-hero-tagline">
                <span>{page.hero.tagline}</span>
              </p>
              <div className="accent-line mi-hero-line-accent" />
              <p className="mi-hero-lead">{page.hero.lead}</p>
              <p className="mi-hero-founder">{page.hero.founder}</p>
            </div>
          </Reveal>

          <div className="mi-hero-stats">
            {page.stats.map((stat, index) => (
              <Reveal key={stat.label} delay={80 + index * 70}>
                <article className="mi-hero-stat">
                  <strong dir="ltr">{stat.value}</strong>
                  <span>{stat.label}</span>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section mi-section">
        <div className="container">
          <Reveal>
            <figure className="mi-figure">
              <img
                src={`${posterBase}/${posters[language] || posters.en}`}
                alt={page.intro.imageAlt}
                width={1024}
                height={572}
                decoding="async"
              />
            </figure>
          </Reveal>
          <Reveal delay={80}>
            <header className="mi-section-head sc-intro-text">
              <span className="eyebrow">{page.intro.eyebrow}</span>
              <h2>{page.intro.title}</h2>
              {page.intro.paragraphs.map((para) => (
                <p key={para}>{para}</p>
              ))}
            </header>
          </Reveal>

          <div className="mi-grid">
            {blocks.map((block, index) => (
              <Reveal
                key={block.title}
                delay={(index % 2) * 70}
                className={`mi-grid-item${block.span ? ' mi-grid-wide' : ''}`}
              >
                <ContentCard block={block} step={index + 1} />
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section mi-closing-section">
        <div className="container">
          <Reveal>
            <article className="mi-closing">
              <div className="mi-hero-glow" aria-hidden="true" />
              <span className="eyebrow">{page.closing.eyebrow}</span>
              <ul className="mi-closing-lines">
                {page.closing.lines.map((line) => (
                  <li key={line}>{line}</li>
                ))}
              </ul>
              <div className="mi-closing-signature">
                <span>{page.closing.tagline}</span>
                <strong>{page.closing.name}</strong>
                <span>{page.closing.role}</span>
                <div className="mi-closing-links">
                  <a href={websiteUrl} target="_blank" rel="noopener noreferrer">
                    <span className="material-symbols-outlined" aria-hidden="true">
                      language
                    </span>
                    {page.closing.websiteLabel}: <span dir="ltr">www.hololrealestate.club</span>
                  </a>
                </div>
              </div>
            </article>
          </Reveal>
        </div>
      </section>
    </main>
  );
}

export default SportsClubsPage;
